export const formatDurationTime = (s: number, roundToHours = false): string => {
  let m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  s %= 60;
  m %= 60;
  if (h === 0 && m === 0) return s + ' s';
  if (h === 0) return `${m} min`;
  return roundToHours ? `~${h}h` : `${h}h ${m} min`;
};
